import styled from 'styled-components';

import { Color } from '../../../constants/Colors';
import { Typography } from '../../../constants/Typographies';

export const StyledTitle = styled.h2`
  ${Typography.XXL}
  color: ${Color.CLOUD_BURST};
  margin-top: 30px;
`;
